import { shopButtonId, shopButtonIdForExt, substitutionButtonId, substitutionButtonIdForExt, defaultPartnerKey } from 'constants'

// By requirements this param has limited size
const PARTNER_QS_RE = /^[a-zA-Z0-9\-_]+$/
const INVALID_CHAR_RE = /[^a-z,]/g
const LEAST_RESERVED_GROCERS = ['walmart', 'fresh', 'target', 'instacart']
const GROCERS_ERROR_MESSAGE = "Keep at least one of 'walmart', 'fresh', 'target', or 'instacart'."
const MAX_UTM_LENGTH = 16

const validateEnabledGrocers = grocers => {
  if (grocers.split(',').filter(grocer => LEAST_RESERVED_GROCERS.includes(grocer)).length === 0) {
    throw new Error(GROCERS_ERROR_MESSAGE)
  }
}

const validateDisabledGrocers = grocers => {
  if (grocers.split(',').filter(grocer => LEAST_RESERVED_GROCERS.includes(grocer)).length >= 3) {
    throw new Error(GROCERS_ERROR_MESSAGE)
  }
}

export const isExtensionContext = () => {
  try {
    return typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.id
  } catch (error) {
    return false
  }
}

export const getShopButtonElement = () => document.getElementById(isExtensionContext() ? shopButtonIdForExt : shopButtonId) || document.createElement('div')
export const getSubstitutionShopButtonElement = () => document.getElementById(isExtensionContext() ? substitutionButtonIdForExt : substitutionButtonId) || document.createElement('div')

export const validateGrocers = (enabledGrocers, disabledGrocers) => {
  if (enabledGrocers && disabledGrocers) {
    throw new Error('Should not use data-retailers and data-disabled-retailers in same time.')
  }

  if (enabledGrocers) {
    if (INVALID_CHAR_RE.test(enabledGrocers)) {
      throw new Error('data-retailers only accept lowercase letter and comma.')
    }
    validateEnabledGrocers(enabledGrocers)
  }

  if (disabledGrocers) {
    if (INVALID_CHAR_RE.test(disabledGrocers)) {
      throw new Error('data-disabled-retailers only accept lowercase letter and comma.')
    }
    validateDisabledGrocers(disabledGrocers)
  }
}

export const getIframeURL = (partnerKey, urlPath) => {
  if (!!partnerKey && partnerKey !== defaultPartnerKey) {
    // do not put 'sc' as partner key into url, 'sc' is not a partner
    return `${process.env.BASE_URL}/${partnerKey}${urlPath}`
  }
  return `${process.env.BASE_URL}${urlPath}`
}

export const getPageUrl = () => {
  return document.querySelector('link[rel="canonical"]')?.href
      || document.querySelector('meta[property="og:url"]')?.content
      || window.location.href
}

export const getHostPageUrl = () => window?.location?.href

export const getQSFromPartner = key => {
  if (key?.length === 0) return undefined
  const qs = new URLSearchParams(window.location.search)
  const value = qs.get(key)
  if (!value) return undefined
  if (!PARTNER_QS_RE.test(value)) {
    console.warn(`Unsupported '${key}' value '${value}'`)
    return undefined
  }
  return value
}

export const getUTMFromPartner = key => {
  const utm = getQSFromPartner(key)
  if (!utm) return undefined
  return utm.slice(0, MAX_UTM_LENGTH)
}

export const getLanguageFromHost = () => {
  // get from meta content-language
  const metaLang = document.querySelector('meta[http-equiv="content-language"]')?.content
  if (metaLang) return metaLang.toLowerCase()

  // if content-language doesn't exist, the get from html lang
  return document.documentElement.lang?.toLowerCase() || undefined
}

export const isValidIntersectionEntry = entry => {
  const { width, height } = entry.boundingClientRect
  return entry.isIntersecting && entry.intersectionRatio > 0 && width > 0 && height > 0
}

export const isPreviewMode = () => {
  return window.location.search.includes('preview=1')
}

// buttonScale must be between 0.5 and 1.
// Returns undefined when value is missing/invalid so callers can fall back to responsive scale.
export const getValidButtonScale = value => {
  if (value === undefined || value === null || value === '') {
    return undefined
  }
  const scale = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(scale) || scale < 0.5 || scale > 1) {
    return undefined
  }
  return scale
}
